import LinkIcon from '@mui/icons-material/Link'
import { Box, IconButton, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'
import { useTranslate } from 'react-admin'

interface CustomTextfieldProps {
  label: string
  value?: string | null
  element?: ReactNode
  link?: string | null
}

const CustomTextfield: FC<CustomTextfieldProps> = ({ label, value, element, link }) => {
  const translate = useTranslate()

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      overflow={'hidden'}
      mb={1}
    >
      <Box sx={{ width: 200, flexShrink: 0 }}>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ minWidth: 200 }}
        >
          {translate(label)}
        </Typography>
      </Box>
      <Box sx={{ flex: 1 }}>
        { !element ? (
          <Typography variant="body1">
            {value ?? '-'}
            { link && (
              <IconButton
                href={link}
                component="a"
                target="_blank"
              >
                <LinkIcon fontSize="small" />
              </IconButton>)}
          </Typography>
        ) : element }
      </Box>
    </Box>
  )
}
export default CustomTextfield
